module.exports = __webpack_public_path__ + "img/benifit-3.4569566.png";